import { Button } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import ZDialog from '../../Shared/Dialogs/ZDialog.jsx'
import GatewayForm from '../Form/GatewayForm.jsx'

const AddGateway = ({ open, onClose, onCreate }) => {
  const [isValid, setIsValid] = useState(false)
  const [formData, setFormData] = useState({})

  const handleCreate = async () => {
    if (!isValid) return

    const payload = {
      ...formData,
      lat: parseFloat(formData.lat),
      lng: parseFloat(formData.lng),
      wmbusId: formData.wmbusId ? formData.wmbusId : null,
      antennaLora: formData.antennaLora ? formData.antennaLora : null,
      antennaWmbus: formData.antennaWmbus ? formData.antennaWmbus : null,
      connectivity: formData.connectivity ? formData.connectivity : null,
      ip: formData.ip ? formData.ip : null
    }

    onCreate(payload)
  }

  const handleClose = () => {
    setFormData({})
    setIsValid(false)
    onClose()
  }

  return (
    <ZDialog
      isOpen={open}
      onClose={handleClose}
      maxWidth="md"
      title={t('gateways.addGateway')}
      content={
        <GatewayForm
          mode="create"
          setIsValid={setIsValid}
          onChange={setFormData}
        />
      }
      actions={
        <Button
          id='gateway-modal-button-create'
          onClick={handleCreate}
          variant="contained"
          disabled={!isValid}
        >
          {t('common.create')}
        </Button>
      }
    />
  )
}

export default AddGateway
